import { Component, Input } from '@angular/core';
import { SoftwareArtifact } from '@nimmsta/ng-commons-lib/models';
import { TranslatePipe } from '@ngx-translate/core';
import { NgClass } from '@angular/common';

export enum ButtonHierarchyLevel {
  FIRST,
  SECOND,
}

@Component({
    selector: 'app-software-artifact-download-button',
    templateUrl: './software-artifact-download-button.component.html',
    imports: [TranslatePipe, NgClass],
})
export class SoftwareArtifactDownloadButtonComponent {
  @Input() artifact!: SoftwareArtifact;

  @Input() hierachyLevel: ButtonHierarchyLevel = ButtonHierarchyLevel.FIRST;

  ButtonHierarchyLevel = ButtonHierarchyLevel;
}
